import { useQueryClient } from "@tanstack/react-query"

import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

import { eventsQueryKeys } from "../../queries/events/queryKeys"
import { reportsQueryKeys } from "../../queries/reports/queryKeys"

import { useIncidentsMutation } from "../useIncidentsMutation"

export function useReportStepUpdate(
    stepId,
    eventId,
    queryParameters,
    config = {},
) {
    const url = `report_steps/${stepId}/`
    const queryClient = useQueryClient()

    return useIncidentsMutation(
        url,
        axiosInstance.patch,
        {
            ...queryParameters,
        },
        {
            ...config, onSuccess: async () => {
                queryClient.invalidateQueries({ queryKey: eventsQueryKeys["detail"](eventId) })
                queryClient.invalidateQueries({ queryKey: reportsQueryKeys["step"](stepId) })
                queryClient.refetchQueries({ queryKey: eventsQueryKeys["detail"](eventId) })
            },
        },
    )
}